import BaseService from '@/services/BaseService'
import { http } from "./config"
class PesquisaSatisfacaoService extends BaseService {
    constructor(){
        super('/v1/crm/pesquisa-satisfacao')
    }

    listar(data){
        const queryParams = `id=${data.id ? data.id : ''}
        &vendaId=${data.vendaId ? data.vendaId : ''}
        &cliente=${data.cliente ? data.cliente : ''}
        `   
        return http.get(`/v1/crm/pesquisa-satisfacao?${queryParams}`)
    }
    atualizar(data){
        const id = data.get('id')
        return http.post(`/v1/crm/pesquisa-satisfacao/${id}`, data)
    }
    gerarFormulario(venda_id){
        return http.post('/v1/crm/pesquisa-satisfacao-gerar-formulario', {venda_id: venda_id})
    }
}

export default new PesquisaSatisfacaoService